
import { Routes, Route, Navigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
 
import Home from './Home';
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import AddInsurancePage from "./pages/AddInsurancePage";
import MyPoliciesPage from "./pages/MyPoliciesPage";
import AgentDashboard from "./agents/Dashboard";
import CompanySelection from "./agents/Company-Selection";
import { AuthProvider, useAuth } from "./context/AuthContext";
import './assets/css/style.scss';
 
import CompanyPage from "./agents/CompanyPage";
import CompanyCustomersPage from "./agents/CompanyCustomersPage";
import CustomerProfilePage from "./agents/CustomerProfilePage";
import CustomerList from "./agents/CustomerList";
import ImportExcelPage from "./agents/ImportExcelPage";
import AddManualCustomer from "./agents/AddManualCustomer";
import DuePaymentsPage from "./agents/DuePaymentsPage";
import ImportReportPage from "./agents/ImportReportPage";
import AddFamilyMember from "./agents/AddFamilyMember";
import FamilyHistory from "./agents/FamilyHistory";
import PolicyAlterations from "./agents/PolicyAlterations";
import PremiumDeposit from "./agents/PremiumDeposit";
import NotificationPage from "./agents/NotificationPage";
import InsuranceCategoryPage from "./agents/InsuranceCategoryPage";
import PolicyDuePage from "./pages/PolicyDuePage";
import PolicyViewPage from "./pages/PolicyViewPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

 
// ✅ Import Agent Layout (Sidebar + NotificationProvider)
import AgentLayout from "./agents/Agentlaout";
import PremiumCalculator from "./agents/PremiumCalculator";
import PaymentPage from "./agents/Payment";
import { useEffect } from "react";
import TermsConditions from "./Terms&Conditions/TermsConditions";
import PrivacyPolicy from "./Terms&Conditions/PrivacyPolicy";
import Disclaimer from "./Terms&Conditions/Disclaimer";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import PolicySubscription from "./pages/PolicySubscription";
 
// const ProtectedRoute = ({ children }) => {
//   const { user } = useAuth();
//   return user ? children : <Navigate to="/login" />;
// };
 
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");


  if (!token) {
    // if no token → redirect to login
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
useEffect(() => {
    // Create or find the <link> element for the favicon
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");

    // Set favicon type and URL (ensure the correct path)
    link.type = "image/png";
    link.rel = "icon";
    link.href = "/favicon.webp";  // Path from public folder

    // Append to <head> to apply it
    document.getElementsByTagName("head")[0].appendChild(link);

    // Set a larger size for high-resolution screens
    link.sizes = "128x128";  // Multiple sizes for different devices (optional)

  }, []);

  return (
    <AuthProvider>
    <ToastContainer position="top-right" closeOnClick newestOnTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        
        {/* Customer Routes wrapped with AgentLayout */}
        <Route
          path="/customer/dashboard"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <Dashboard />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/mypolicies"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <MyPoliciesPage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/addinsurance"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <AddInsurancePage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/due-payments"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <PolicyDuePage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer/policy-view/:customerId/:policyId/:policyNumber"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <PolicyViewPage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
 
        {/* Agent Routes */}
        <Route path="/agent/company-selection" element={<CompanySelection />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/subscription" element={<PolicySubscription />} />
  
        {/* ✅ All agent routes wrapped inside AgentLayout */}
  <Route
  path="/agent/dashboard"
  element={
    <ProtectedRoute>
      <AgentLayout>
        <AgentDashboard />
      </AgentLayout>
    </ProtectedRoute>
  }
/>
        <Route
          path="/agent/companies"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <CompanyPage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
<Route
  path="/payment/:id"
  element={
    <ProtectedRoute>
      <AgentLayout>
        <PaymentPage />
      </AgentLayout>
    </ProtectedRoute>
  }
/>
        <Route
  path="/agent/company/:companyName/:policyType?"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <CompanyCustomersPage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/company/:id"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <CompanyCustomersPage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/customer/:id"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <CustomerProfilePage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/customers"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <CustomerList />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/import-excel"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <ImportExcelPage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/add-manual"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <AddManualCustomer />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/due-payments"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <DuePaymentsPage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/report"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <ImportReportPage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/add-family"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <AddFamilyMember />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/family-history"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <FamilyHistory />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/policy-alterations"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <PolicyAlterations />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/agent/premium-deposit"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <PremiumDeposit />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
       
        <Route
          path="/agent/notification"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <NotificationPage />
              </AgentLayout>
            </ProtectedRoute>
          }
        />
 
        <Route
          path="/agent/premium-calculater"
          element={
            <ProtectedRoute>
              <AgentLayout>
                <PremiumCalculator/>
              </AgentLayout>
            </ProtectedRoute>
          }
        />
 
        {/* Other Routes */}
        <Route path="/select-insurance" element={<InsuranceCategoryPage />} />
 
      </Routes>
    </AuthProvider>
  );
}
 
export default App;
 